import { Col, Container, Row } from '@slal/ui/layout';
import { StyledHeading } from '../Layout/styles';
import { StyledHeadingWrapper } from './styles';
import { BannerProps } from './types';

export const PageBanner = ({ title, id }: BannerProps) => {
    return (
        <StyledHeadingWrapper role="banner">
            <Container>
                <Row>
                    <Col md={8} xl={7}>
                        <StyledHeading id={id} level={1}>
                            {title}
                        </StyledHeading>
                    </Col>
                </Row>
            </Container>
        </StyledHeadingWrapper>
    );
};
